import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { AppFacadeService } from '../../services/app-facade.service';
import { Invoice } from '../../models/invoice-model';
import { Subscription } from 'rxjs';
import { INVOICE_MAX_SELECTION_ALLOWED } from '../../constants/default.const';

@Component({
    standalone: false,
    selector: 'por-multi-payment-invoice-panel',
    templateUrl: './multi-payment-invoice-panel.component.html',
    styleUrls: ['./multi-payment-invoice-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiPaymentInvoicePanelComponent implements OnInit, OnDestroy {
    readonly appFacadeService = inject(AppFacadeService);

    @Input() isOpen = false; // Overlay open/close state
    @Input() trigger!: CdkOverlayOrigin; // Overlay trigger passed from parent
    @Input() featureName = 'invoice-multipayment-panel';
    @Output() readonly closeOverlay = new EventEmitter<void>(); // Emit event to parent when closing

    private readonly subscriptions: Subscription[] = [];
    total = 0;
    selectedInvoice = 0;

    // Expose constant to template for translation parameter
    readonly maxInvoicesAllowed = INVOICE_MAX_SELECTION_ALLOWED;

    // Tracks whether the selection has ever been non-empty, so an empty emission that
    // arrives before the panel has any selection (e.g. on initial subscribe) does not close it.
    private hasHadSelection = false;

    ngOnInit(): void {
        this.subscriptions.push(
            this.appFacadeService.getInvoicesTotal().subscribe(total => {
                this.total = total;
            }),
            this.appFacadeService.getSelectedInvoices().subscribe(selectedInvoices => {
                this.selectedInvoice = selectedInvoices.length;
                if (selectedInvoices.length > 0) {
                    this.hasHadSelection = true;
                } else if (this.hasHadSelection) {
                    // Removing the last selected invoice closes the panel
                    this.closeOverlay.emit();
                }
            })
        );
    }

    closeOverlayClick(): void {
        this.closeOverlay.emit();
    }

    removeInvoices(invoice: Invoice | Invoice[]) {
        const invoiceIds: string[] = Array.isArray(invoice)
            ? invoice.map(i => i.Id) // If multiple invoices, get their IDs
            : [invoice.Id]; // If single invoice, create an array with its ID
        this.appFacadeService.unsetSelectedInvoices(invoiceIds);
    }

    onClickContinue(): void {
        if (this.total >= 1) {
            this.closeOverlay.emit();
            this.appFacadeService.invoiceMultiPaymentContinue();
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
